import { useState } from 'react';
import { ReactComponent as InboxSvg } from '../../assets/svg/inbox.svg';
import { ReactComponent as ChevronDownSvg } from '../../assets/svg/chevron-down.svg';
import { NAVIGATION } from '../../types/enum';
import request from '../../lib/request';
import NotificationItem from './notificationItem';
import PopUpNotification from '../../components/popupNotification';

const Notification = ({
  notification,
  currentNav,
  handleCurrentNav,
  closeDialog,
  getNotification,
  systemNotification,
}) => {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [popUpBody, setPopUpBody] = useState({});

  const handleClickNotification = ({ id, location, isRead }) => {
    return async () => {
      if (!isRead) {
        await markAsRead(id);

        if (NAVIGATION[location] === currentNav) {
          await getNotification({ next: false });
        }
      }

      closeDialog();
      handleCurrentNav(NAVIGATION[location])();
    };
  };

  const markAsRead = async (id) => {
    try {
      if (id) {
        await request.put(`/notification/${id}?mark=read`);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const markAllAsRead = async () => {
    try {
      if (!window.confirm('Are you sure you want to mark all as read?')) {
        return;
      }
      await request.put(`/notification?mark=read`);
      await getNotification({ next: false });
    } catch (err) {
      console.log(err);
    }
  };

  const removeAllRead = async () => {
    try {
      if (!window.confirm('Are you sure you want to remove all read items?')) {
        return;
      }
      await request.delete(`/notification?mark=read`);
      await getNotification({ next: false });
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenPopUp = (body) => () => {
    setPopUpBody(body);
    setPopUpOpen(true);
  };

  const handleClosePopUp = () => {
    setPopUpOpen(false);
    setPopUpBody({});
  };

  return (
    <>
      {systemNotification.map((noti) => (
        <div
          key={noti.id}
          className='mb-4'
          onClick={handleOpenPopUp(noti)}
        >
          <NotificationItem item={noti} />
        </div>
      ))}
      {notification.list?.length > 0 ? (
        <div className='text-sm space-y-4'>
          <div className='flex justify-between items-center'>
            <button
              className='font-bold text-xs text-red-500'
              onClick={removeAllRead}
            >
              Remove All Read
            </button>
            <button
              className={`font-bold text-xs ${
                !notification.unreadCount && 'opacity-40'
              }`}
              onClick={markAllAsRead}
              disabled={!notification.unreadCount}
            >
              Mark All as Read
            </button>
          </div>
          {notification.list.map((noti) => (
            <NotificationItem
              key={noti.id}
              item={noti}
              handleClickNotification={handleClickNotification}
            />
          ))}
          {notification.total.count >
            notification.total.page * notification.total.perPage && (
            <div
              className='flex justify-center'
              onClick={async () => getNotification({ next: true })}
            >
              <ChevronDownSvg />
            </div>
          )}
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center gap-4 h-96'>
          <InboxSvg className='size-16 opacity-10' />
          <p className='text-sm opacity-30'>Empty</p>
        </div>
      )}
      {popUpOpen && (
        <PopUpNotification
          open={popUpOpen}
          title={popUpBody.title}
          close={handleClosePopUp}
        >
          <div>{popUpBody.content}</div>
        </PopUpNotification>
      )}
    </>
  );
};

export default Notification;
